export enum CallHistoryType {
  guest = "顧客",
  cast = "キャスト",
  driver = "ドライバー",
  staff = "スタッフ",
  other = "その他",
}
